module.exports = __webpack_public_path__ + "static/img/B (33).c651f1ba.png";